<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <app-page-container v-if="(is_general_manager || is_reservations_department) && leads.length" extra>
        <app-cells>
          <h2 class="title">Unassigned clients</h2>
        </app-cells>
        <app-res-top
          v-for="lead in leads"
          :key="`lead_${lead.id}`"
          @assignManagerPopup="assignManagerPopup"
          @leadPatch="leadPatch"
          :manager-crop-url="lead.manager?.crop?.crop_url"
          :manager-full-name="lead.manager.full_name"
          :lead-name="lead.name"
          :lead-id="lead.id"
          :lead-hotels-count="lead.reservations_hotels_count"
          :is-lead-res-manager="lead.reservation_manager"
        />
        <app-cells :position="pagination_leads.pages > 1 ? 'between' : 'end'">
          <paginate
            :clickHandler="onClickLeadsPagination"
            v-if="pagination_leads.pages > 1"
            v-model="pagination_leads.page"
            :page-count="pagination_leads.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
          <app-table-records :all="pagination_leads.count" :count="leads.length" :page="pagination_leads.page" :limit="5" />
        </app-cells>
      </app-page-container>
      <app-page-container extra :min-height="200">
        <app-flex-grid :rows="[['240px', '220px', 1, '240px']]">
          <template #col-1-1>
            <app-input
              @input.native="onReservationSearch"
              v-model="search"
              type="search"
              placeholder="Search by client, lead number"
              name="search"
            />
          </template>
          <template #col-1-2>
            <app-select
              v-if="(is_general_manager || is_reservation_supervisor)"
              @input="onChangeFilters"
              v-model="reservation_manager"
              :options="reservation_manager_options"
              :reduce="item => item.id"
              :filterable="false"
              :searchable="false"
              label="full_name"
              placeholder="Reservation manager"
            />
          </template>
          <template #col-1-3>
            <app-select
              @input="onChangeFilters"
              v-model="filter_hotel"
              :reduce="item => item.id"
              :options="filter_hotel_options"
              placeholder="Hotel"
            />
          </template>
          <template #col-1-4>
            <app-select
              v-if="is_general_manager || is_sales_supervisor || is_reservations_department"
              @input="onChangeFilters"
              v-model="sales_manager"
              :reduce="item => item.id"
              :options="sales_manager_options"
              label="full_name"
              placeholder="Sales manager"
            />
          </template>
        </app-flex-grid>
        <app-spinner v-if="!is_list_loaded" />
        <template v-else>
          <template v-if="already_booked.length">
            <app-cells>
              <h2 class="title">Already booked. Just confirm and fill the info</h2>
            </app-cells>
            <AppAccHotel
              v-for="(reservation, index) in already_booked"
              :key="`already_booked_${reservation.id}`"
              :reservation="reservation"
              :order-number="index + 1"
              :countdown="reservation.last_email_sent_at"
            />
            <app-cells :position="pagination_already_booked.pages > 1 ? 'between' : 'end'">
              <paginate
                :clickHandler="onClickAlreadyBookedPagination"
                v-if="pagination_already_booked.pages > 1"
                v-model="pagination_already_booked.page"
                :page-count="pagination_already_booked.pages"
                :prev-text="'<'"
                :next-text="'>'"
                :container-class="'pagination'"
                :page-class="'pagination__item'"
                :page-link-class="'pagination__link'"
                :prev-class="'pagination__item pagination__item--prev'"
                :next-class="'pagination__item pagination__item--next'"
                :next-link-class="'pagination__link pagination__link--next'"
                :prev-link-class="'pagination__link pagination__link--prev'"
              />
              <app-table-records :all="pagination_already_booked.count" :count="already_booked.length" :page="pagination_already_booked.page" />
            </app-cells>
          </template>
          <app-cells>
            <h2 class="title">Waiting hotel</h2>
          </app-cells>
          <template v-if="new_reservations.length">
            <AppAccHotel
              v-for="(reservation, index) in new_reservations"
              :key="`new_reservation_${reservation.id}`"
              :reservation="reservation"
              :order-number="index + 1"
              :countdown="reservation.last_email_sent_at"
            />
            <app-cells :position="pagination_new_reservations.pages > 1 ? 'between' : 'end'">
              <paginate
                :clickHandler="onClickNewReservationsPagination"
                v-if="pagination_new_reservations.pages > 1"
                v-model="pagination_new_reservations.page"
                :page-count="pagination_new_reservations.pages"
                :prev-text="'<'"
                :next-text="'>'"
                :container-class="'pagination'"
                :page-class="'pagination__item'"
                :page-link-class="'pagination__link'"
                :prev-class="'pagination__item pagination__item--prev'"
                :next-class="'pagination__item pagination__item--next'"
                :next-link-class="'pagination__link pagination__link--next'"
                :prev-link-class="'pagination__link pagination__link--prev'"
              />
              <app-table-records :all="pagination_new_reservations.count" :count="new_reservations.length" :page="pagination_new_reservations.page" />
            </app-cells>
          </template>
          <app-no-results v-else text="There’s no bookings yet" />
          <template v-if="confirm_booking.length">
            <app-cells>
              <h2 class="title">Confirm booking</h2>
            </app-cells>
            <AppAccHotel
              v-for="(reservation, index) in confirm_booking"
              :key="`confirm_booking_${reservation.id}`"
              :reservation="reservation"
              :order-number="index + 1"
              :countdown="reservation.last_email_sent_at"
            />
            <app-cells :position="pagination_confirm_booking.pages > 1 ? 'between' : 'end'">
              <paginate
                :clickHandler="onClickConfirmBookingPagination"
                v-if="pagination_confirm_booking.pages > 1"
                v-model="pagination_confirm_booking.page"
                :page-count="pagination_confirm_booking.pages"
                :prev-text="'<'"
                :next-text="'>'"
                :container-class="'pagination'"
                :page-class="'pagination__item'"
                :page-link-class="'pagination__link'"
                :prev-class="'pagination__item pagination__item--prev'"
                :next-class="'pagination__item pagination__item--next'"
                :next-link-class="'pagination__link pagination__link--next'"
                :prev-link-class="'pagination__link pagination__link--prev'"
              />
              <app-table-records :all="pagination_confirm_booking.count" :count="confirm_booking.length" :page="pagination_confirm_booking.page" />
            </app-cells>
          </template>
          <template v-if="book_provisionally.length">
            <app-cells>
              <h2 class="title">Book provisionally</h2>
            </app-cells>
            <AppAccHotel
              v-for="(reservation, index) in book_provisionally"
              :key="`book_provisionally_${reservation.id}`"
              :reservation="reservation"
              :order-number="index + 1"
              :countdown="reservation.last_email_sent_at"
            />
            <app-cells :position="pagination_book_provisionally.pages > 1 ? 'between' : 'end'">
              <paginate
                :clickHandler="onClickBookProvisionallyPagination"
                v-if="pagination_book_provisionally.pages > 1"
                v-model="pagination_book_provisionally.page"
                :page-count="pagination_book_provisionally.pages"
                :prev-text="'<'"
                :next-text="'>'"
                :container-class="'pagination'"
                :page-class="'pagination__item'"
                :page-link-class="'pagination__link'"
                :prev-class="'pagination__item pagination__item--prev'"
                :next-class="'pagination__item pagination__item--next'"
                :next-link-class="'pagination__link pagination__link--next'"
                :prev-link-class="'pagination__link pagination__link--prev'"
              />
              <app-table-records :all="pagination_book_provisionally.count" :count="book_provisionally.length" :page="pagination_book_provisionally.page" />
            </app-cells>
          </template>
          <template v-if="requested_provisional_extension.length">
            <app-cells>
              <h2 class="title">Requested provisional extension</h2>
            </app-cells>
            <AppAccHotel
              v-for="(reservation, index) in requested_provisional_extension"
              :key="`requested_provisional_extension_${reservation.id}`"
              :reservation="reservation"
              :order-number="index + 1"
              :countdown="reservation.last_email_sent_at"
            />
            <app-cells :position="pagination_requested_provisional_extension.pages > 1 ? 'between' : 'end'">
              <paginate
                :clickHandler="onClickRequestedProvisionalExtensionPagination"
                v-if="pagination_requested_provisional_extension.pages > 1"
                v-model="pagination_requested_provisional_extension.page"
                :page-count="pagination_requested_provisional_extension.pages"
                :prev-text="'<'"
                :next-text="'>'"
                :container-class="'pagination'"
                :page-class="'pagination__item'"
                :page-link-class="'pagination__link'"
                :prev-class="'pagination__item pagination__item--prev'"
                :next-class="'pagination__item pagination__item--next'"
                :next-link-class="'pagination__link pagination__link--next'"
                :prev-link-class="'pagination__link pagination__link--prev'"
              />
              <app-table-records
                :all="pagination_requested_provisional_extension.count"
                :count="requested_provisional_extension.length"
                :page="pagination_requested_provisional_extension.page"
              />
            </app-cells>
          </template>
          <template v-if="booked_provisionally.length">
            <app-cells>
              <h2 class="title">Booked provisionally</h2>
            </app-cells>
            <AppAccHotel
              v-for="(reservation, index) in booked_provisionally"
              :key="`booked_provisionally_${reservation.id}`"
              :reservation="reservation"
              :order-number="index + 1"
            />
            <app-cells :position="pagination_booked_provisionally.pages > 1 ? 'between' : 'end'">
              <paginate
                :clickHandler="onClickBookedProvisionallyPagination"
                v-if="pagination_booked_provisionally.pages > 1"
                v-model="pagination_booked_provisionally.page"
                :page-count="pagination_booked_provisionally.pages"
                :prev-text="'<'"
                :next-text="'>'"
                :container-class="'pagination'"
                :page-class="'pagination__item'"
                :page-link-class="'pagination__link'"
                :prev-class="'pagination__item pagination__item--prev'"
                :next-class="'pagination__item pagination__item--next'"
                :next-link-class="'pagination__link pagination__link--next'"
                :prev-link-class="'pagination__link pagination__link--prev'"
              />
              <app-table-records :all="pagination_booked_provisionally.count" :count="booked_provisionally.length" :page="pagination_booked_provisionally.page" />
            </app-cells>
          </template>
          <template v-if="booked.length">
            <app-cells>
              <h2 class="title">Booked</h2>
            </app-cells>
            <AppAccHotel
              v-for="(reservation, index) in booked"
              :key="`booked_${reservation.id}`"
              :reservation="reservation"
              :order-number="index + 1"
            />
            <app-cells :position="pagination_booked.pages > 1 ? 'between' : 'end'">
              <paginate
                :clickHandler="onClickBookedPagination"
                v-if="pagination_booked.pages > 1"
                v-model="pagination_booked.page"
                :page-count="pagination_booked.pages"
                :prev-text="'<'"
                :next-text="'>'"
                :container-class="'pagination'"
                :page-class="'pagination__item'"
                :page-link-class="'pagination__link'"
                :prev-class="'pagination__item pagination__item--prev'"
                :next-class="'pagination__item pagination__item--next'"
                :next-link-class="'pagination__link pagination__link--next'"
                :prev-link-class="'pagination__link pagination__link--prev'"
              />
              <app-table-records :all="pagination_booked.count" :count="booked.length" :page="pagination_booked.page" />
            </app-cells>
          </template>
          <template v-if="wait_sales_action.length">
            <app-cells>
              <h2 class="title">Wait sales action</h2>
            </app-cells>
            <AppAccHotel
              v-for="(reservation, index) in wait_sales_action"
              :key="`wait_sales_action_${reservation.id}`"
              :reservation="reservation"
              :order-number="index + 1"
              :countdown="reservation.reservation_status_last_updated_at"
            />
            <app-cells :position="pagination_wait_sales_action.pages > 1 ? 'between' : 'end'">
              <paginate
                :clickHandler="onClickWaitSalesActionPagination"
                v-if="pagination_wait_sales_action.pages > 1"
                v-model="pagination_wait_sales_action.page"
                :page-count="pagination_wait_sales_action.pages"
                :prev-text="'<'"
                :next-text="'>'"
                :container-class="'pagination'"
                :page-class="'pagination__item'"
                :page-link-class="'pagination__link'"
                :prev-class="'pagination__item pagination__item--prev'"
                :next-class="'pagination__item pagination__item--next'"
                :next-link-class="'pagination__link pagination__link--next'"
                :prev-link-class="'pagination__link pagination__link--prev'"
              />
              <app-table-records :all="pagination_wait_sales_action.count" :count="wait_sales_action.length" :page="pagination_wait_sales_action.page" />
            </app-cells>
          </template>
        </template>
      </app-page-container>
    </template>
    <modal
      name="manager"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('manager')" class="popup__close" type="button"></button>
        <div class="popup__title">Assign reservation manager</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckManagerForm">
            <app-form-group label="Reservation manager" required>
              <app-select
                v-model="manager.reservation_manager"
                :reduce="item => item.id"
                :options="reservation_manager_options"
                :clearable="false"
                label="full_name"
                placeholder="Choose manager"
                :error="$v.manager.reservation_manager.$error"
              />
              <template #error>
                <div v-if="$v.manager.reservation_manager.$dirty && !$v.manager.reservation_manager.required">Required field</div>
              </template>
            </app-form-group>
            <app-cells position="center" :indent="false">
              <app-button :disabled="$v.manager.$error" type="submit" ref="submit_manager">Assign manager</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { getReservationsHotelsList, patchLead, getLeads, getUsers, getHotelsListSearch } from '@/http'
import AppAccHotel from '@/components/AppAccHotel.vue'
import debounce from 'lodash/debounce'
import { required } from 'vuelidate/lib/validators'
import AppResTop from '@/components/AppResTop.vue'

export default {
  name: 'HotelsReservationsListUpcoming',
  components: { AppResTop, AppAccHotel },
  data() {
    return {
      is_loaded: false,
      is_list_loaded: true,
      leads: [],
      new_reservations: [],
      confirm_booking: [],
      book_provisionally: [],
      booked_provisionally: [],
      requested_provisional_extension: [],
      booked: [],
      wait_sales_action: [],
      search: null,
      reservation_manager: null,
      reservation_manager_options: [],
      pagination_leads: {
        pages: 1,
        page: 1,
        count: 1,
      },
      pagination_new_reservations: {
        pages: 1,
        page: 1,
        count: 1,
      },
      pagination_already_booked: {
        pages: 1,
        page: 1,
        count: 1,
      },
      pagination_confirm_booking: {
        pages: 1,
        page: 1,
        count: 1,
      },
      pagination_book_provisionally: {
        pages: 1,
        page: 1,
        count: 1,
      },
      pagination_booked_provisionally: {
        pages: 1,
        page: 1,
        count: 1,
      },
      pagination_requested_provisional_extension: {
        pages: 1,
        page: 1,
        count: 1,
      },
      pagination_booked: {
        pages: 1,
        page: 1,
        count: 1,
      },
      pagination_wait_sales_action: {
        pages: 1,
        page: 1,
        count: 1,
      },
      manager: {},
      managers_options: [],
      already_booked: [],
      filter_hotel: null,
      filter_hotel_options: [],
      sales_manager: null,
      sales_manager_options: [],
    }
  },
  validations: {
    manager: {
      reservation_manager: { required }
    }
  },
  computed: {
    is_general_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager')
    },
    is_reservations_department() {
      return this.$store.state.userGroups.map(item => item.code).includes('reservation_manager')
        || this.$store.state.userGroups.map(item => item.code).includes('reservation_assistant')
        || this.$store.state.userGroups.map(item => item.code).includes('reservation_supervisor')
    },
    is_reservation_supervisor() {
      return this.$store.state.userGroups.map(item => item.code).includes('reservation_supervisor')
    },
    is_sales_supervisor() {
      return this.$store.state.userGroups.map(item => item.code).includes('sales_supervisor')
    },
  },
  created() {
    this.fetchLeads()
    this.fetchReservations()
    getUsers({ is_active: true, group: 'reservation_supervisor,reservation_manager,reservation_supervisor' })
      .then(res => { this.reservation_manager_options = res.data })
    getHotelsListSearch({ active: true }).then(res => { this.filter_hotel_options = res.data })
    getUsers({ group: 'sales_manager', is_active: true }).then(response => { this.sales_manager_options = response.data })
  },
  methods: {
    onClickAlreadyBookedPagination(page) {
      this.pagination_already_booked.page = page
      this.fetchAlreadyBooked()
    },
    onClickLeadsPagination(page) {
      this.pagination_leads.page = page
      this.fetchLeads()
    },
    onClickNewReservationsPagination(page) {
      this.pagination_new_reservations.page = page
      this.fetchNewReservations()
    },
    onClickConfirmBookingPagination(page) {
      this.pagination_confirm_booking.page = page
      this.fetchConfirmBooking()
    },
    onClickBookProvisionallyPagination(page) {
      this.pagination_book_provisionally.page = page
      this.fetchBookProvisionally()
    },
    onClickBookedProvisionallyPagination(page) {
      this.pagination_booked_provisionally.page = page
      this.fetchBookedProvisionally()
    },
    onClickRequestedProvisionalExtensionPagination(page) {
      this.pagination_requested_provisional_extension.page = page
      this.fetchRequestedProvisionalExtension()
    },
    onClickBookedPagination(page) {
      this.pagination_booked.page = page
      this.fetchBooked()
    },
    onClickWaitSalesActionPagination(page) {
      this.pagination_wait_sales_action.page = page
      this.fetchWaitSalesAction()
    },
    fetchLeads() {
      getLeads({
        reservation_manager_assigned: false,
        reservations_hotels: true,
        page: this.pagination_leads.page,
        page_size: 5,
      })
        .then(res => {
          this.leads = res.data.results
          this.pagination_leads.pages = res.data.pages
          this.pagination_leads.count = res.data.count
        })
    },
    fetchAlreadyBooked() {
      getReservationsHotelsList({
        category: 'upcoming',
        reservation_manager_assigned: true,
        reservation_status: 'new',
        sales_status_exclude: 'cancel',
        ordering: 'last_email_sent_at',
        already_booked: true,
        reservation_manager: this.search ? '' : this.reservation_manager,
        search: this.search,
        page: this.pagination_already_booked.page,
        page_size: 20,
      })
        .then(res => {
          this.already_booked = res.data.results
          this.pagination_already_booked.pages = res.data.pages
          this.pagination_already_booked.count = res.data.count
        })
    },
    fetchNewReservations() {
      getReservationsHotelsList({
        category: 'upcoming',
        reservation_manager_assigned: true,
        reservation_status: 'new',
        sales_status_exclude: 'cancel',
        ordering: 'last_email_sent_at',
        already_booked: false,
        reservation_manager: this.search ? '' : this.reservation_manager,
        search: this.search,
        page: this.pagination_new_reservations.page,
        page_size: 20,
      })
        .then(res => {
          this.new_reservations = res.data.results
          this.pagination_new_reservations.pages = res.data.pages
          this.pagination_new_reservations.count = res.data.count
        })
    },
    fetchConfirmBooking() {
      getReservationsHotelsList({
        category: 'upcoming',
        reservation_manager_assigned: true,
        reservation_status_exclude: 'booked,new',
        sales_status: 'book',
        ordering: 'last_email_sent_at',
        reservation_manager: this.search ? '' : this.reservation_manager,
        search: this.search,
        page: this.pagination_confirm_booking.page,
        page_size: 20,
      })
        .then(res => {
          this.confirm_booking = res.data.results
          this.pagination_confirm_booking.pages = res.data.pages
          this.pagination_confirm_booking.count = res.data.count
        })
    },
    fetchBookProvisionally() {
      getReservationsHotelsList({
        category: 'upcoming',
        reservation_manager_assigned: true,
        reservation_status_exclude: 'booked_provisionally,new',
        sales_status: 'book_provisionally',
        sales_status_exclude: 'book',
        ordering: 'last_email_sent_at',
        reservation_manager: this.search ? '' : this.reservation_manager,
        search: this.search,
        page: this.pagination_book_provisionally.page,
        page_size: 20,
      })
        .then(res => {
          this.book_provisionally = res.data.results
          this.pagination_book_provisionally.pages = res.data.pages
          this.pagination_book_provisionally.count = res.data.count
        })
    },
    fetchBookedProvisionally() {
      getReservationsHotelsList({
        category: 'upcoming',
        reservation_manager_assigned: true,
        reservation_status: 'booked_provisionally',
        sales_status_exclude: 'book',
        provisional_extension: false,
        reservation_manager: this.search ? '' : this.reservation_manager,
        ordering: 'reservation_deadline',
        search: this.search,
        page: this.pagination_booked_provisionally.page,
        page_size: 20,
      })
        .then(res => {
          this.booked_provisionally = res.data.results
          this.pagination_booked_provisionally.pages = res.data.pages
          this.pagination_booked_provisionally.count = res.data.count
        })
    },
    fetchRequestedProvisionalExtension() {
      getReservationsHotelsList({
        category: 'upcoming',
        reservation_manager_assigned: true,
        reservation_status: 'booked_provisionally',
        sales_status_exclude: 'book',
        provisional_extension: true,
        reservation_manager: this.search ? '' : this.reservation_manager,
        ordering: 'last_email_sent_at',
        search: this.search,
        page: this.pagination_requested_provisional_extension.page,
        page_size: 20,
      })
        .then(res => {
          this.requested_provisional_extension = res.data.results
          this.pagination_requested_provisional_extension.pages = res.data.pages
          this.pagination_requested_provisional_extension.count = res.data.count
        })
    },
    fetchBooked() {
      getReservationsHotelsList({
        category: 'upcoming',
        reservation_manager_assigned: true,
        reservation_status: 'booked',
        reservation_manager: this.search ? '' : this.reservation_manager,
        search: this.search,
        page: this.pagination_booked.page,
        page_size: 20,
      })
        .then(res => {
          this.booked = res.data.results
          this.pagination_booked.pages = res.data.pages
          this.pagination_booked.count = res.data.count
        })
    },
    fetchWaitSalesAction() {
      getReservationsHotelsList({
        category: 'upcoming',
        reservation_manager_assigned: true,
        reservation_status: 'available',
        sales_status_exclude: 'book_provisionally,book,cancel',
        reservation_manager: this.search ? '' : this.reservation_manager,
        search: this.search,
        page: this.pagination_wait_sales_action.page,
        page_size: 20,
      })
        .then(res => {
          this.wait_sales_action = res.data.results
          this.pagination_wait_sales_action.pages = res.data.pages
          this.pagination_wait_sales_action.count = res.data.count
        })
    },
    fetchReservations() {
      Promise.all([
        getReservationsHotelsList({
          category: 'upcoming',
          reservation_manager_assigned: true,
          reservation_status: 'new',
          sales_status_exclude: 'cancel',
          ordering: 'last_email_sent_at',
          already_booked: false,
          reservation_manager: this.reservation_manager,
          search: this.search,
          hotel_id: this.filter_hotel,
          sales_manager: this.sales_manager,
          page: this.pagination_new_reservations.page,
          page_size: 20,
        }),
        getReservationsHotelsList({
          category: 'upcoming',
          reservation_manager_assigned: true,
          reservation_status_exclude: 'booked,new,not_available',
          sales_status: 'book',
          ordering: 'last_email_sent_at',
          reservation_manager: this.search ? '' : this.reservation_manager,
          search: this.search,
          hotel_id: this.filter_hotel,
          sales_manager: this.sales_manager,
          page: this.pagination_confirm_booking.page,
          page_size: 20,
        }),
        getReservationsHotelsList({
          category: 'upcoming',
          reservation_manager_assigned: true,
          reservation_status_exclude: 'booked_provisionally,new,not_available',
          sales_status: 'book_provisionally',
          sales_status_exclude: 'book',
          ordering: 'last_email_sent_at',
          reservation_manager: this.search ? '' : this.reservation_manager,
          search: this.search,
          hotel_id: this.filter_hotel,
          sales_manager: this.sales_manager,
          page: this.pagination_book_provisionally.page,
          page_size: 20,
        }),
        getReservationsHotelsList({
          category: 'upcoming',
          reservation_manager_assigned: true,
          reservation_status: 'booked_provisionally',
          sales_status_exclude: 'book',
          provisional_extension: false,
          reservation_manager: this.search ? '' : this.reservation_manager,
          ordering: 'reservation_deadline',
          search: this.search,
          hotel_id: this.filter_hotel,
          sales_manager: this.sales_manager,
          page: this.pagination_booked_provisionally.page,
          page_size: 20,
        }),
        getReservationsHotelsList({
          category: 'upcoming',
          reservation_manager_assigned: true,
          reservation_status: 'booked',
          reservation_manager: this.search ? '' : this.reservation_manager,
          search: this.search,
          hotel_id: this.filter_hotel,
          sales_manager: this.sales_manager,
          page: this.pagination_booked.page,
          page_size: 20,
        }),
        getReservationsHotelsList({
          category: 'upcoming',
          reservation_manager_assigned: true,
          reservation_status: 'available',
          sales_status_exclude: 'book_provisionally,book,cancel',
          reservation_manager: this.search ? '' : this.reservation_manager,
          search: this.search,
          hotel_id: this.filter_hotel,
          sales_manager: this.sales_manager,
          page: this.pagination_wait_sales_action.page,
          page_size: 20,
        }),
        getReservationsHotelsList({
          category: 'upcoming',
          reservation_manager_assigned: true,
          reservation_status: 'booked_provisionally',
          sales_status_exclude: 'book',
          provisional_extension: true,
          reservation_manager: this.search ? '' : this.reservation_manager,
          ordering: 'last_email_sent_at',
          search: this.search,
          hotel_id: this.filter_hotel,
          sales_manager: this.sales_manager,
          page: this.pagination_requested_provisional_extension.page,
          page_size: 20,
        }),
        getReservationsHotelsList({
          category: 'upcoming',
          reservation_manager_assigned: true,
          reservation_status: 'new',
          sales_status_exclude: 'cancel',
          ordering: 'last_email_sent_at',
          already_booked: true,
          reservation_manager: this.search ? '' : this.reservation_manager,
          search: this.search,
          page: this.pagination_already_booked.page,
          page_size: 20,
        })
      ])
        .then(res => {
          this.new_reservations = res[0].data.results
          this.pagination_new_reservations.pages = res[0].data.pages
          this.pagination_new_reservations.count = res[0].data.count
          this.confirm_booking = res[1].data.results
          this.pagination_confirm_booking.pages = res[1].data.pages
          this.pagination_confirm_booking.count = res[1].data.count
          this.book_provisionally = res[2].data.results
          this.pagination_book_provisionally.pages = res[2].data.pages
          this.pagination_book_provisionally.count = res[2].data.count
          this.booked_provisionally = res[3].data.results
          this.pagination_booked_provisionally.pages = res[3].data.pages
          this.pagination_booked_provisionally.count = res[3].data.count
          this.booked = res[4].data.results
          this.pagination_booked.pages = res[4].data.pages
          this.pagination_booked.count = res[4].data.count
          this.wait_sales_action = res[5].data.results
          this.pagination_wait_sales_action.pages = res[5].data.pages
          this.pagination_wait_sales_action.count = res[5].data.count
          this.requested_provisional_extension = res[6].data.results
          this.pagination_requested_provisional_extension.pages = res[6].data.pages
          this.pagination_requested_provisional_extension.count = res[6].data.count
          this.already_booked = res[7].data.results
          this.pagination_already_booked.pages = res[7].data.pages
          this.pagination_already_booked.count = res[7].data.count
          this.is_loaded = true
          this.is_list_loaded = true
        })
    },
    assignManagerPopup(id) {
      this.$modal.show('manager')
      this.manager.id = id
    },
    onCheckManagerForm() {
      this.$v.manager.$touch()
      if (this.$v.manager.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendManagerForm()
      }
    },
    sendManagerForm() {
      this.$refs.submit_manager.preload = true
      patchLead(this.manager.id, { reservation_manager: this.manager.reservation_manager })
        .finally(() => { this.$refs.submit_manager.preload = false })
        .then(() => {
          this.fetchLeads()
          this.fetchReservations()
          this.$modal.hide('manager')
          this.$notify({
            type: 'success',
            title: 'Reservation manager assigned',
          })
        })
    },
    leadPatch(lead_id) {
      patchLead(lead_id, { reservation_manager: this.$store.state.userData.id })
        .then(() => {
          this.fetchLeads()
          this.fetchReservations()
          this.$notify({
            type: 'success',
            title: 'Reservation assigned',
          })
        })
    },
    onReservationSearch() {
      this.reservation_manager = ''
      this.filter_hotel = null
      this.sales_manager = null
      this.searchReservation(this)
      this.is_list_loaded = false
    },
    searchReservation: debounce(vm => {
      vm.fetchReservations()
    }, 350),
    onChangeFilters() {
      this.pagination_new_reservations.page = 1
      this.pagination_confirm_booking.page = 1
      this.pagination_book_provisionally.page = 1
      this.pagination_booked_provisionally.page = 1
      this.pagination_booked.page = 1
      this.pagination_wait_sales_action.page = 1
      this.search = ''
      this.is_list_loaded = false
      this.fetchReservations()
    },
  }
}
</script>

